import { Node, ResolvedPos } from 'prosemirror-model'

import { schema } from 'prose-core'

const ContainerDepths = {
  [schema.nodes.unordered_list.name]: 1,
  [schema.nodes.ordered_list.name]: 1,
  [schema.nodes.check_list.name]: 1,
}

export const getContainerDepth = (nodeTypeName: string): number => ContainerDepths[nodeTypeName] || 0

// if we are before a node, return the start of the node at container depth (which is potentially the same position)
// if we are IN a node, jump to the start of (before) the node and resolve the same way as described before
export const getContainerBeforePos = (doc: Node, pos: number): ResolvedPos & { nodeAfter: Node } => {
  return doc.resolve(getPosOfParentContainer(doc, pos)) as ResolvedPos & { nodeAfter: Node }
}

export const getPosOfParentContainer = (doc: Node, pos: number): number => {
  if (pos === doc.nodeSize - 2) pos -= 1 // if we are at the end of a full doc
  // selection, the caller probably wants the last container's before position.
  // This is not completely true to the name of this function, but it resolves
  // boilerplate in the calling code

  const $pos = doc.resolve(pos)
  const node = $pos.nodeAfter

  if (!node || node.isInline) {
    return getPosOfParentContainer(doc, $pos.start($pos.depth) - 1)
  }

  let containerDepth = getContainerDepth(node.type.name)
  const containerStart = $pos.start($pos.depth + 1 - containerDepth)

  return Math.max(containerStart - 1, 0)
}
